// extracted by mini-css-extract-plugin
export default {"radio":"SuperRadio_radio__daxRV","label":"SuperRadio_label__5wDoR","options":"SuperRadio_options__NfKHF"};